module.exports = __webpack_public_path__ + "img/menu-right-body.8a9afb90.svg";